var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { Icon } from "../../tremor/Icon";
import { Input } from "../../tremor/Input";
import { Button } from "../../tremor/Button";
import { useEffect, useState } from "react";
import { create } from "zustand";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { useBackend } from "../../layouts/Wrapper";
import { Text, Label, Title } from "../../tremor/Text";
import Editor from "@monaco-editor/react";
import { twMerge } from "tailwind-merge";
import { ChevronLeftIcon, ChevronRightIcon, PlayIcon, } from "@heroicons/react/20/solid";
import ChartBase from "../Chart/ChartBase";
import { Card } from "../../tremor/Card";
import { toast } from "sonner";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { WidgetWizard } from "../WidgetWizard";
import { LogType } from "@onvo-ai/js";
import { useTheme } from "../../layouts/Dashboard/useTheme";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../tremor/Select";
import { MultiSelect } from "../../tremor/MultiSelect";
import { Divider } from "../../tremor/Divider";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../tremor/Tabs";
import { Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRoot, TableRow, } from "../../tremor/Table";
const hashCode = function (s) {
    return s.split("").reduce(function (a, b) {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a;
    }, 0);
};
export const useManualWidgetModal = create((set) => ({
    open: false,
    setOpen: (op, wid) => set({ open: op, widget: wid }),
}));
export const ManualWidgetModal = ({}) => {
    var _a, _b;
    const { dashboard, datasources, refreshWidgets } = useDashboard();
    const { backend, adminMode } = useBackend();
    const theme = useTheme();
    const { open, setOpen, widget } = useManualWidgetModal();
    const [output, setOutput] = useState(null);
    const [title, setTitle] = useState("");
    const [settings, setSettings] = useState({});
    const [code, setCode] = useState("");
    const [config, setConfig] = useState({});
    const [loading, setLoading] = useState(false);
    const [datasource, setDatasource] = useState({ label: "", value: "" });
    const [columns, setColumns] = useState([]);
    const [groupBy, setGroupBy] = useState(null);
    const [data, setData] = useState([]);
    const constructCode = () => {
        let dfColumns = columns.map(a => `'${a}'`).join(", ");
        let groupByCode = "";
        if (groupBy) {
            const otherColumns = columns.filter(a => a !== groupBy);
            groupByCode = `
  # Group by ${groupBy}
  df = df.groupby('${groupBy}').agg({${otherColumns.map(a => `'${a}': 'sum'`).join(',')}})
  df = df.reset_index()
        `;
        }
        let newCode = `
def main():
  # Load necessary columns from the first CSV file
  df = pd.read_csv('/tmp/${datasource.value}.csv', usecols=[${dfColumns}])
    ${groupByCode}
  return df
`;
        setCode(newCode);
    };
    useEffect(() => {
        constructCode();
    }, [
        datasource,
        groupBy,
        columns
    ]);
    const getCache = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!widget)
            return;
        let cache = yield (backend === null || backend === void 0 ? void 0 : backend.widget(widget.id).cache());
        let rawCache = yield (backend === null || backend === void 0 ? void 0 : backend.widget(widget.id).cache({ raw: true }));
        if (cache) {
            setOutput(cache);
        }
        if (rawCache) {
            setData(rawCache);
        }
    });
    useEffect(() => {
        if (widget) {
            setCode(widget.code);
            let conf = widget.config;
            let meta = conf._internal;
            delete conf._internal;
            setConfig(conf);
            getCache();
            setTitle(widget.title);
            setSettings(widget.settings || {});
            if (meta) {
                setDatasource({ label: meta.datasource, value: meta.datasource });
                setColumns(meta.columns);
                setGroupBy(meta.groupBy);
            }
        }
    }, [widget]);
    useEffect(() => {
        if (!data || data.length === 0)
            return;
        if (!config || Object.keys(config).length == 0 || !config.options || !config.options.plugins) {
            return;
        }
        let columns = Object.keys(data[0]);
        let out = JSON.stringify(config);
        columns.forEach(col => {
            out = out.replace(`"{{data['${col}']}}"`, JSON.stringify(data.map((a) => a[col])));
        });
        setOutput(JSON.parse(out));
    }, [data, config]);
    const saveChanges = () => {
        if (!widget || !backend)
            return;
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            yield backend.widgets.update(widget.id, {
                title: title,
                code: code,
                cache: output,
                settings: settings,
                messages: [],
                config: Object.assign(Object.assign({}, config), { _internal: {
                        datasource: datasource.value,
                        columns: columns,
                        groupBy: groupBy
                    } }),
                error: null,
            });
            yield (backend === null || backend === void 0 ? void 0 : backend.widget(widget.id).executeCode());
            return true;
        }), {
            loading: "Saving changes...",
            success: () => {
                refreshWidgets(backend);
                return "Changes saved!";
            },
            error: (error) => "Failed to save changes: " + error.message,
        });
    };
    const executeCode = (str) => __awaiter(void 0, void 0, void 0, function* () {
        if (str.search("pd.read_csv") === -1)
            return;
        setLoading(true);
        if (!widget)
            return;
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            yield (backend === null || backend === void 0 ? void 0 : backend.widgets.update(widget.id, { code: str }));
            yield (backend === null || backend === void 0 ? void 0 : backend.widget(widget.id).executeCode());
            let newData = yield (backend === null || backend === void 0 ? void 0 : backend.widget(widget.id).cache());
            setOutput(newData);
            if (backend) {
                backend.logs.create({
                    type: LogType.EditWidget,
                    dashboard: widget.dashboard,
                    widget: widget.id,
                });
            }
        }), {
            loading: "Executing code...",
            success: () => {
                setLoading(false);
                return "Successfully executed code";
            },
            error: (e) => {
                setLoading(false);
                return "Failed to execute code: " + e.message;
            },
        });
    });
    if (!((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.can_create_widgets) && !adminMode)
        return React.createElement(React.Fragment, null);
    const Preview = (React.createElement("div", { className: "onvo-relative onvo-h-full onvo-w-full onvo-p-4 onvo-background-color onvo-bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] dark:onvo-bg-[radial-gradient(#0f172a_1px,transparent_1px)] [background-size:16px_16px] onvo-flex onvo-justify-center onvo-items-center" },
        loading && (React.createElement("div", { className: "onvo-absolute onvo-top-0 onvo-left-0 onvo-bottom-0 onvo-right-0 onvo-z-10 onvo-backdrop-blur-md onvo-bg-white/50 dark:onvo-bg-black-900/50 onvo-flex onvo-justify-center onvo-items-center" },
            React.createElement(Card, { className: "onvo-loading-card onvo-foreground-color onvo-flex onvo-flex-row onvo-gap-6 onvo-items-center !onvo-w-72 onvo-border-white/10 dark:onvo-border-black-900/10" },
                React.createElement("div", { role: "status" },
                    React.createElement("svg", { "aria-hidden": "true", className: "onvo-inline onvo-w-10 onvo-h-10 onvo-text-gray-200 onvo-animate-spin dark:onvo-text-gray-600 onvo-fill-blue-600", viewBox: "0 0 100 101", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("path", { d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", fill: "currentColor" }),
                        React.createElement("path", { d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", fill: "currentFill" }))),
                React.createElement(Title, null, "Regenerating chart")))),
        React.createElement(Card, { className: "onvo-foreground-color onvo-relative onvo-flex onvo-w-full onvo-flex-col onvo-py-3 " +
                ((output === null || output === void 0 ? void 0 : output.type) === "metric"
                    ? "onvo-h-32"
                    : "onvo-h-72 @xl/widgetmodal:onvo-h-96") }, output && (React.createElement(ChartBase, { json: Object.assign(Object.assign({}, output), { options: Object.assign(Object.assign({}, output.options), { animation: {
                        duration: 0
                    } }) }), title: title, settings: {}, key: title + hashCode(JSON.stringify(settings) + JSON.stringify(output)) })))));
    return (React.createElement(React.Fragment, null,
        React.createElement("dialog", { open: open },
            React.createElement("div", { className: twMerge("onvo-@container/widgetmodal onvo-h-full onvo-animate-dialogOpen onvo-w-full onvo-z-50 onvo-fixed onvo-left-0 onvo-top-0 onvo-foreground-color") },
                React.createElement("div", { className: "onvo-foreground-color onvo-w-full onvo-left-0 onvo-top-0 onvo-z-10 onvo-flex onvo-flex-row onvo-justify-start onvo-items-center onvo-gap-4 onvo-border-solid onvo-border-b onvo-border-black/10 onvo-p-2 dark:onvo-border-white/10" },
                    React.createElement(Icon, { icon: ChevronLeftIcon, variant: "shadow", className: "onvo-ml-2 onvo-background-color onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10", onClick: () => setOpen(false) }),
                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-w-full onvo-gap-1 onvo-flex-grow onvo-justify-start onvo-items-center" },
                        React.createElement(Text, { className: "onvo-hidden @xl/widgetmodal:onvo-block" }, dashboard === null || dashboard === void 0 ? void 0 : dashboard.title),
                        React.createElement(ChevronRightIcon, { className: "onvo-hidden @xl/widgetmodal:onvo-block onvo-h-4 onvo-w-4 dark:onvo-fill-slate-500" }),
                        React.createElement(Label, null, widget ? (widget.title || "Edit Widget") : "Create widget")),
                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-gap-2 onvo-flex-shrink-0" },
                        React.createElement(Button, { onClick: saveChanges, className: "onvo-flex-shrink-0", isLoading: loading }, widget ? "Save" : "Create"))),
                React.createElement("div", { className: "onvo-relative onvo-flex onvo-flex-grow onvo-h-[calc(100%-52px)] onvo-w-full" },
                    React.createElement(PanelGroup, { autoSaveId: "edit-widget", direction: "horizontal" },
                        React.createElement(Panel, { defaultSize: 50, minSize: 25 },
                            React.createElement(Tabs, { defaultValue: "tab1" },
                                React.createElement(TabsList, { className: "onvo-mt-3" },
                                    React.createElement(TabsTrigger, { value: "tab1" }, "Configure"),
                                    React.createElement(TabsTrigger, { value: "tab2" }, "Code")),
                                React.createElement(TabsContent, { value: "tab1" },
                                    React.createElement("div", { className: "onvo-h-[calc(100vh-94px)] onvo-relative onvo-overflow-y-auto onvo-scrollbar-thin onvo-flex-grow onvo-w-full onvo-p-4 onvo-flex onvo-flex-col onvo-gap-2" },
                                        React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-gap-2" },
                                            React.createElement(Label, { className: "onvo-w-24 onvo-flex-shrink-0" }, "Datasource"),
                                            React.createElement(Select, { value: datasource.value, onValueChange: val => {
                                                    const selected = datasources.find(a => a.id === val);
                                                    if (!selected)
                                                        return;
                                                    setDatasource({ label: selected.title, value: selected.id });
                                                } },
                                                React.createElement(SelectTrigger, null,
                                                    React.createElement(SelectValue, { placeholder: "Select" })),
                                                React.createElement(SelectContent, null, datasources.map((item) => (React.createElement(SelectItem, { key: item.id, value: item.id }, item.title)))))),
                                        (datasource && datasource.value) && (React.createElement(React.Fragment, null,
                                            React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-gap-2" },
                                                React.createElement(Label, { className: "onvo-w-24 onvo-flex-shrink-0" }, "Columns"),
                                                React.createElement(MultiSelect, { value: columns, onValueChange: setColumns, items: ((_b = datasources.find(a => a.id === datasource.value)) === null || _b === void 0 ? void 0 : _b.columns.map((item) => ({
                                                        label: item.title,
                                                        value: item.title
                                                    }))) || [] })),
                                            columns.length > 0 && (React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-gap-2" },
                                                React.createElement(Label, { className: "onvo-w-24 onvo-flex-shrink-0" }, "Group by"),
                                                React.createElement(Select, { value: groupBy || undefined, onValueChange: val => {
                                                        setGroupBy(val === "" ? null : val);
                                                    } },
                                                    React.createElement(SelectTrigger, null,
                                                        React.createElement(SelectValue, { placeholder: "None" })),
                                                    React.createElement(SelectContent, null, columns.map((item) => (React.createElement(SelectItem, { key: item, value: item }, item))))))))),
                                        React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-justify-end onvo-w-full" },
                                            React.createElement(Button, { onClick: () => executeCode(code) }, "Fetch data")),
                                        React.createElement(Divider, null),
                                        (columns.length > 0) && (React.createElement(WidgetWizard, { columns: columns, onChange: setConfig, config: config })))),
                                React.createElement(TabsContent, { value: "tab2" },
                                    React.createElement("div", { className: "onvo-flex onvo-flex-col onvo-h-[calc(100vh-94px)]" },
                                        React.createElement("div", { className: "onvo-flex onvo-px-3 onvo-py-2 onvo-flex-row onvo-justify-between onvo-items-center onvo-border-b onvo-border-black/10 dark:onvo-border-white/10" },
                                            React.createElement(Text, { className: "onvo-font-semibold" }, "Code editor"),
                                            React.createElement(Button, { variant: "secondary", onClick: () => executeCode(code) },
                                                " ",
                                                React.createElement(PlayIcon, { className: "onvo-h-4 onvo-w-4 onvo-mr-2" }),
                                                "Run code")),
                                        React.createElement("div", { className: "onvo-flex-grow onvo-h-full onvo-relative" },
                                            React.createElement(Editor, { defaultLanguage: "python", value: code, height: "100%", options: {
                                                    padding: {
                                                        top: 10,
                                                    },
                                                }, className: "onvo-code-editor onvo-w-full", theme: theme === "dark" ? "vs-dark" : "light", onChange: (val) => setCode(val || "") })))))),
                        React.createElement(PanelResizeHandle, { className: "onvo-w-[1px] onvo-border-0 onvo-bg-black/10 dark:onvo-bg-white/10 hover:onvo-bg-black/50 dark:hover:onvo-bg-white/50 active:onvo-bg-black/50 dark:active:onvo-bg-white/50" }),
                        React.createElement(Panel, { minSize: 25 },
                            React.createElement("div", { className: "onvo-h-full onvo-flex onvo-flex-shrink-0 @xl/widgetmodal:onvo-flex-shrink onvo-flex-col onvo-justify-center onvo-w-full onvo-flex-grow onvo-relative onvo-overflow-y-auto" },
                                React.createElement("div", { className: "onvo-border-b onvo-border-black/10 dark:onvo-border-white/10 onvo-p-3 onvo-w-full onvo-flex onvo-flex-row onvo-items-center onvo-justify-between onvo-gap-2" },
                                    React.createElement(Text, { className: "onvo-text-sm" }, "Title"),
                                    React.createElement(Input, { placeholder: "Title", className: "onvo-text-xs", value: title, inputClassName: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10", onChange: (val) => setTitle(val.target.value) })),
                                React.createElement(PanelGroup, { autoSaveId: "edit-widget-code", direction: "vertical" },
                                    React.createElement(Panel, { defaultSize: 80, minSize: 20 }, Preview),
                                    React.createElement(PanelResizeHandle, { className: "onvo-h-[1px] onvo-bg-black/10 dark:onvo-bg-white/10 hover:onvo-bg-black/50 dark:hover:onvo-bg-white/50 active:onvo-bg-black/50 dark:active:onvo-bg-white/50" }),
                                    React.createElement(Panel, { minSize: 10 },
                                        React.createElement("div", { className: "onvo-flex onvo-flex-col onvo-h-full" },
                                            React.createElement("div", { className: "onvo-flex-grow onvo-h-full onvo-relative" },
                                                React.createElement(TableRoot, null,
                                                    React.createElement(Table, null,
                                                        React.createElement(TableHead, null,
                                                            React.createElement(TableRow, null, columns.map(a => (React.createElement(TableHeaderCell, { key: a }, a))))),
                                                        React.createElement(TableBody, null, data.map((item, index) => (React.createElement(TableRow, { key: index }, columns.map(a => (React.createElement(TableCell, { key: index + a }, item[a])))))))))))))))))))));
};
//# sourceMappingURL=ManualWidgetModal.js.map